import {
  get,
  getWithAuth,
  postWithAuthLocal,
  postAuth,
  post,
  getAuth,
  postWithAuth,
  deleteWithAuth,
  putWithAuth,
  putWithAuthLocal
} from "../services/api/client";
import { apiClient } from "../services/api/config";

import { apiVariables, getUrlWithParams } from "../services/api/apiVariables";

import {
  WorkShiftResponse,
  AttractiveAppearanceResponse,
  religiousAssociationResponse,
  
  ethnicityResponse,
  
  GenderResponse,
  MaritalStatusResponse,
  ITSpecialtyResponse,
  SaveProfileResponse,
  SaveMatchesResponse,
  GetUserProfileResponse,
  UploadImageResponse,
  DeleteImageResponse,
  SetMainProfileImageResponse,
  GetMatchesResponse,
  UserProfileResponse,
  MatchPreferenceResponse,
  MessageListResponse,
  NotificationListResponse,
  NotificationItem,
  ValidateNpiResponse,
  SkillsResponse,
  WorkTypeResponse,
  ViewPostResponse,
  ViewPostData,
  PostItem,
  TrendingHashtag,
  AvailabilityTypeResponse,
  ExploreTechnologiesCategoryResponse,
 ExploreTechnologiesResponse,
  GroupResponse,
  SaveGroupMemberResponse,
  SaveUserAvailabilityPayload,
  SaveUserAvailabilityResponse,
  GroupMessagesResponse
} from "../types/admin";

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getEthnicity = () =>
  getWithAuth<ethnicityResponse>(apiVariables.ADMIN_ETHNICITY);


export const getReligions = () =>
  getWithAuth<religiousAssociationResponse>(apiVariables.ADMIN_RELIGIOUSASSOCIATION);

export const Admin_WorkShift_LIST = () =>
  getWithAuth<WorkShiftResponse>(apiVariables.Admin_WorkShift);

export const Admin_Ethinicity_List = () =>
  getWithAuth<ethnicityResponse>(apiVariables.ADMIN_ETHNICITY);

export const Admin_Gender_LIST = () =>
  getWithAuth<GenderResponse>(apiVariables.Admin_Genders);

export const Admin_MaritalStatus_LIST = () =>
  getWithAuth<MaritalStatusResponse>(apiVariables.Admin_MaritalStatus);

export const Admin_ITSpecialty_LIST = () =>
  getWithAuth<ITSpecialtyResponse>(apiVariables.Admin_ITSpecialty);

export const Admin_AttractiveAppearance = () =>
  get<AttractiveAppearanceResponse>(apiVariables.Admin_AttractiveAppearance);

// Profile saves can include a photo upload alongside all other profile
// fields, so give this call more headroom than the default API timeout.
const SAVE_USER_DETAIL_TIMEOUT_MS = 60000;

export const Admin_SaveUserDetail = (formData: FormData, token?: string) =>
  post<SaveProfileResponse>(
    apiVariables.Admin_SaveUserDetail,
    formData,
    true,
    token,
    SAVE_USER_DETAIL_TIMEOUT_MS
  );

export const Admin_GetUserDetail_LIST = (userId: string, authToken: string) =>
  getAuth<GetUserProfileResponse>(
    `${apiVariables.Admin_GetUserDetail}`,
    authToken
  );

export const UserProfile_GetByUserId = (userId: string) =>
  getWithAuth<UserProfileResponse>(
    `${apiVariables.UserProfile_GetByUserId}${userId}`
  );

  export const UserProfile_GetbymatchuserId = (userId: string) =>
  getWithAuth<UserProfileResponse>(
    `${apiVariables.UserProfile_GetbymatchuserId}${userId}`
  );

export const Admin_UploadUserImage = (formData: FormData, authToken: string) =>
  postWithAuth<UploadImageResponse>(
    apiVariables.Admin_UploadUserImage,
    formData,
    authToken
  );

export const Admin_DeleteUserImage = (imageId: string, authToken: string) =>
  deleteWithAuth<DeleteImageResponse>(
    `${apiVariables.Admin_DeleteUserImage}${imageId}`,
    authToken
  );

export const Admin_SetMainProfileImage = (
  userId: string,
  photoId: number,
  authToken: string
) =>
  postWithAuth<SetMainProfileImageResponse>(
    apiVariables.Admin_SetMainProfileImage,
    { userId, photoId },
    authToken
  );

export const GetMaches = () =>
  getWithAuth<GetMatchesResponse>(apiVariables.GetMatches);

export const GetRefineMaches = (payload: Record<string, any>) =>
  postAuth<GetMatchesResponse>(
    apiVariables.GetRefineMatches,
    payload
  );

export const Admin_SaveMatches = (payload: any) =>
  postWithAuthLocal<SaveMatchesResponse>(
    apiVariables.SaveMatches,
    payload
  );

export const GetUser_MatchingPreferences = (userId?: string) =>
  getWithAuth<MatchPreferenceResponse>(
    `${apiVariables.GetUserMatchingPreferences}${userId}`
  );

interface MessageHistoryData {
  conversationId: string;
  messages: any[];
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const Admin_GetMessageList = (authToken: string) =>
  getAuth<MessageListResponse>(
    apiVariables.GetMessageList,
    authToken
  );

export const Admin_GetMessageHistory = (
  receiverId: string,
  authToken: string
) =>
  getAuth<ApiResponse<MessageHistoryData>>(
    apiVariables.GetMessageHistory,
    authToken,
    {
      receiverId,
      page: 1,
      pageSize: 100
    }
  );

export const Admin_GetGroupMessages = (
  groupId: number,
  page: number,
  pageSize: number
) =>
  getWithAuth<GroupMessagesResponse>(
    getUrlWithParams(`${apiVariables.GetGroupMessages}/${groupId}`, {
      page,
      pageSize,
    })
  );

export const Admin_GetNotifications = (authToken: string) =>
  getAuth<NotificationItem[] | NotificationListResponse>(
    apiVariables.NOTIFICATION_LIST,
    authToken
  );

export const Admin_MarkNotificationRead = (
  notificationId: string,
  authToken: string
) =>
  putWithAuth<any>(
    apiVariables.NOTIFICATION_MARK_READ(notificationId),
    {},
    authToken
  );

export const Admin_MarkAllNotificationsRead = (authToken: string) =>
  putWithAuth<any>(
    apiVariables.NOTIFICATION_MARK_ALL_READ,
    {},
    authToken
  );
export const Admin_ValidateNPI = (npiNumber: string) =>
  postAuth<ValidateNpiResponse>(
    apiVariables.VALIDATE_NPI_NUMBER,
    { npiNumber }
  );
  export const Admin_Skills_LIST = () =>
  getWithAuth<SkillsResponse>(apiVariables.Admin_ITSkills);

  export const Admin_WorkTypes_LIST = () =>
  getWithAuth<WorkTypeResponse>(apiVariables.Admin_WorkTypes);

// Media posts can take longer than standard API requests while the file is uploaded.
const POST_MEDIA_UPLOAD_TIMEOUT_MS = 120000;

export const Admin_SavePost = (data: any) =>
  postWithAuthLocal<any>(
    apiVariables.POST_CREATE_WITH_MEDIA,
    data,
    POST_MEDIA_UPLOAD_TIMEOUT_MS
  );
  export const Admin_UpdatePost = (data: any) =>
  putWithAuthLocal<any>(
    apiVariables.POST_UPDATE_WITH_MEDIA,
    data
  );
  export const Admin_GetPostById = (postId: number | string) =>
  getWithAuth<{
    success: boolean;
    statusCode: number;
    message: string | null;
    data: PostItem;
    errors: string[] | null;
  }>(
    `${apiVariables.POST_GET_BY_ID}${postId}`
  );
export const Admin_ViewPosts = (payload: any) =>
  postWithAuthLocal<ViewPostResponse>(
    apiVariables.ViewPosts,
    payload
  );

export const Admin_DeletePost = async (postId: number) => {
  const response = await apiClient.delete(`${apiVariables.POST_GET_BY_ID}${postId}`);
  return response.data;
};

export const Admin_GetTrendingHashtags = () =>
  getWithAuth<TrendingHashtag[]>(apiVariables.TrendingHashtags);

export const GetTrendingByHashtag = (
  hashtag: string,
  params?: Record<string, unknown>
) =>
  getWithAuth<ViewPostData>(
    `${apiVariables.GetTrendingByHashtag}${encodeURIComponent(hashtag)}`,
    params
  );


export const Admin_TogglePostLike = (payload: {
  postId: number;
  userId: string;
  reactionTypeId: number;
}) =>
  postWithAuthLocal<any>(
    apiVariables.PostLikeToggle,
    payload
  );

export const Admin_PostComment = (payload: {
  commentId: number;
  userId: string;
  postId?: number;
  commentText?: string;
}) =>
  postWithAuthLocal<any>(
    apiVariables.PostComment,
    payload
  );

export const Admin_GetPostAttachmentSasUrl = (attachmentId: number | string) =>
  apiClient.get<{
    success: boolean;
    statusCode: number;
    message: string | null;
    data: string | null;
    fileUrl: string | null;
    errors: string[] | null;
  }>(
    `${apiVariables.POST_ATTACHMENT_SAS_URL}${attachmentId}`
  );

export const Admin_GetUserPhotoSasUrl = (photoId: number | string) =>
  apiClient.get<{
    success: boolean;
    statusCode: number;
    message: string | null;
    data: string | null;
    fileUrl: string | null;
    errors: string[] | null;
  }>(
    `${apiVariables.GetPhotoSasUrlByPhotoId}${photoId}`
  );

export const Admin_AvailabilityType_LIST = () =>
  getWithAuth<AvailabilityTypeResponse>(
    apiVariables.Admin_AvailabilityType
  );

export const getAvailabilityTypes = () =>
  getWithAuth<AvailabilityTypeResponse>(
    apiVariables.Admin_AvailabilityType
  );

export const getUserAvailability = () =>
  getWithAuth<SaveUserAvailabilityResponse>(
    apiVariables.UserAvailability
  );

export const createUserAvailability = (
  payload: SaveUserAvailabilityPayload
) =>
  postWithAuthLocal<SaveUserAvailabilityResponse>(
    apiVariables.UserAvailability,
    {
      ...payload,
      availabilityTypeIds: payload.isAvailable ? payload.availabilityTypeIds : [],
    }
  );

export const updateUserAvailability = (
  availabilityId: number,
  payload: SaveUserAvailabilityPayload
) =>
  putWithAuthLocal<SaveUserAvailabilityResponse>(
    `${apiVariables.UserAvailability}/${availabilityId}`,
    {
      ...payload,
      availabilityId,
      availabilityTypeIds: payload.isAvailable ? payload.availabilityTypeIds : [],
    }
  );

  export const Admin_ExploreTechnologiesCategory_LIST = () =>
  getWithAuth<ExploreTechnologiesCategoryResponse>(
    apiVariables.Admin_ExploreTechnologiesCategory
  );

export const Admin_ExploreTechnologies_LIST = () =>
  getWithAuth<ExploreTechnologiesResponse>(
    apiVariables.Admin_ExploreTechnologies
  );
export const GetAllGroups = () =>
  getWithAuth<GroupResponse>(
    apiVariables.GetAllGroups
  );

export const AddMembersToExistingGroup = (
  payload: any,
  authToken: string
) =>
  postWithAuth<SaveGroupMemberResponse>(
    apiVariables.AddMembersToExistingGroup,
    payload,
    authToken
  );
